export default "__VITE_ASSET__C0KUJs45__"